// frontend/src/askos/liveSessions/LiveTranscriptPanel.js
//
// Live-updating transcript of whichever audio (original or a dubbed
// language) the student currently has selected — sourced from
// LiveSessionTranscript rows the Ubuntu relay POSTs in near-real-time.
// Polling (no WebSocket precedent in this app), same shape as
// LiveQAWidget.js. Resets to empty whenever `language` changes, so
// switching the audio dropdown shows that language's transcript from the
// start rather than appending onto the previous language's lines.
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getLiveSessionTranscript, downloadLiveSessionTranscript } from '../../api/liveSessionsApi';

const POLL_MS = 5000;

const LiveTranscriptPanel = ({ slug, sessionId, language }) => {
    const [lines, setLines] = useState([]);
    const sinceIdRef = useRef(0);
    const scrollRef = useRef(null);

    const poll = useCallback(() => {
        getLiveSessionTranscript(slug, sessionId, language, sinceIdRef.current)
            .then(({ lines: newLines, latest_id: latestId }) => {
                if (!newLines.length) return;
                sinceIdRef.current = latestId;
                setLines(prev => [...prev, ...newLines]);
            })
            .catch(() => {});
    }, [slug, sessionId, language]);

    useEffect(() => {
        setLines([]);
        sinceIdRef.current = 0;
        poll();
        const interval = setInterval(poll, POLL_MS);
        return () => clearInterval(interval);
    }, [poll]);

    useEffect(() => {
        if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }, [lines]);

    return (
        <div style={{ background: '#fff', borderRadius: 12, padding: 16, marginTop: 16, color: '#1a1a1a' }}>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="fw-bold mb-0" style={{ color: '#1a1a1a' }}>Live Transcript</h6>
                <button
                    type="button"
                    className="primary-btn"
                    style={{ padding: '4px 12px', fontSize: 12 }}
                    disabled={!lines.length}
                    onClick={() => downloadLiveSessionTranscript(slug, sessionId, language)}
                >
                    Download (.txt)
                </button>
            </div>
            <div ref={scrollRef} style={{ maxHeight: 260, overflowY: 'auto' }}>
                {lines.length === 0 && <p className="empty-note" style={{ color: '#666' }}>Transcript will appear here as the lecture proceeds.</p>}
                {lines.map(l => (
                    <p key={l.id} style={{ fontSize: 13, marginBottom: 8, color: '#1a1a1a' }}>{l.text}</p>
                ))}
            </div>
        </div>
    );
};

export default LiveTranscriptPanel;
